
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('paginate-filter-3')]),_c('path',{attrs:{"d":"M5.25 0.746h16.5s1.5 0 1.5 1.5v16.5s0 1.5 -1.5 1.5H5.25s-1.5 0 -1.5 -1.5v-16.5s0 -1.5 1.5 -1.5","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M20.25 23.246h-18a1.5 1.5 0 0 1 -1.5 -1.5v-18","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M11.25 8.246a1.5 1.5 0 0 1 1.5 -1.5l1.135 0a1.873 1.873 0 0 1 -0.008 3.745 1.873 1.873 0 0 1 0.008 3.746l-1.135 0a1.5 1.5 0 0 1 -1.5 -1.5","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    